import React from 'react';
import { inject } from 'mobx-react';
import { Spring, animated } from 'react-spring';
import styled from 'styled-components';

import { boxShadow } from 'js/config/style';
import DeliveryProgress from 'js/components/core/DeliveryProgress';

const Progress = styled(DeliveryProgress)`
  display: grid;
  justify-content: center;
  margin-top: 2rem;
  background: white;
  border-radius: 0.25rem;
  box-shadow: ${boxShadow};
  padding: 2rem 0;
`;

export default inject('page')(({ page }) => (
  <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }}>
    {animation => (
      <animated.div style={animation}>
        <Progress shipment={page.shipment_tracking} />
      </animated.div>
    )}
  </Spring>
));
